import React from 'react';
import { PropTypes } from 'prop-types';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Typography, Grid } from '@mui/material';
import { darkTheme } from 'daaas-ui';

import ContentContainer from './ContentContainer';
import ContentSection from './ContentSection';

// images import
import squigglyLineDAS from '../../assets/images/squigglyLineDAS.svg';
import squigglyShapes from '../../assets/images/squigglyShapes.svg';

const Root = styled('div')(({ theme }) => ({
  '& .brandingDAS__squigglyLine': {
    marginTop: theme.spacing(24),
    marginBottom: theme.spacing(4),
  },

  '& .brandingDAS__DAS': {
    maxWidth: '350px',
    color: darkTheme.palette.background.paper,
    fontSize: `5rem !important`,
    lineHeight: '0.9375',
  },

  '& .brandingDAS__slogan': {
    color: darkTheme.palette.background.paper,
    fontSize: `1.6875rem !important`,
    fontWeight: 700,
  },
}));

export default function BrandingDAS({ button = null }) {
  const { t } = useTranslation(['landing', 'common']);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const isMdScreen = windowWidth < darkTheme.breakpoints.values.md;

  React.useEffect(() => {
    // Detect screen size
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    window.addEventListener('ScreenOrientation', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('ScreenOrientation', handleResize);
    };
  }, []);

  return (
    <Root>
      {isMdScreen ? (
        <img
          src={squigglyShapes}
          alt=""
          className="brandingDAS__squigglyLine"
          loading="lazy"
        />
      ) : (
        <img
          src={squigglyLineDAS}
          alt=""
          className="brandingDAS__squigglyLine"
          loading="lazy"
        />
      )}
      <ContentContainer paddingBottom={false}>
        <ContentSection>
          <Grid container justifyContent="center">
            <Grid item>
              <Typography
                className="brandingDAS__DAS"
                variant="h1"
                component="h2"
                color="textPrimary"
              >
                {t('common:daaas')}
              </Typography>
              <Typography
                sx={{ mt: 1, mb: 2 }}
                className="brandingDAS__slogan"
                variant="h3"
                component="h3"
                color="textPrimary"
              >
                {t('slogan')}
              </Typography>
              {button}
            </Grid>
          </Grid>
        </ContentSection>
      </ContentContainer>
    </Root>
  );
}

BrandingDAS.propTypes = {
  button: PropTypes.node,
};
